import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import _ from 'lodash'

// components
import { Button, TextInput } from 'components/shard'

// const
import { Size, Color } from 'const'
import Alert from 'components/Alert'

import { usePasswordHook } from 'hooks'

function Password() {
  const [values, setValues] = useState({})
  const { errors, setErrors, sendmailSchema, execSendMail, isSendingMail, isSuccess, history } = usePasswordHook()

  useEffect(() => {
    if (_.isEmpty(values)) {
      return
    }

    execSendMail(values.tanakaId)
  }, [values, execSendMail])

  useEffect(() => {
    if (isSuccess) {
      history.push('/password/sendmail')
    }
  }, [history, isSuccess])

  return (
    <Wrapper>
      {errors.length > 0 && (
        <Alert type="error" message="エラー" description={errors.join('\n')} onClose={() => setErrors([])} />
      )}
      <Title>パスワード再発行</Title>
      <Message>TANAKA-ID ご来店時登録いただいたID（メールアドレス）を入力してください</Message>
      <FormWrapper>
        <Formik
          initialValues={{ tanakaId: '' }}
          onSubmit={(values) => {
            setValues(values)
          }}
          validationSchema={sendmailSchema}
        >
          {({ values, handleChange, handleBlur, handleSubmit, dirty, isValid }) => (
            <form
              onSubmit={(e) => {
                handleSubmit(e)
                e.preventDefault() // useEffectでstateを更新するためにcomponentの自動更新を防ぐ
              }}
            >
              <TextInput
                type="email"
                name="tanakaId"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.tanakaId}
                ariaLabel="tanakaId"
                placeholder="TANAKA-ID（メールアドレス）"
                errorMessage={<ErrorMessage name="tanakaId" />}
              />
              <ButtonWrapper>
                <Button type={'submit'} primary disabled={!isValid || !dirty || isSendingMail}>
                  確認メール送信
                </Button>
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 80px 100px 50px 400px 1fr;
`

const Title = styled.div`
  grid-row: 2;
  display: flex;
  align-items: flex-end;
  font-size: ${Size.FONT.HEADLINE.LEARGE};
  padding-bottom: 20px;
`

const Message = styled.div`
  grid-row: 3;
  padding: 8px 0;
  color: ${Color.FONT.ANNOTATION};
  border-bottom: 1px solid ${Color.LINE.NORMAL};
`

const FormWrapper = styled.div`
  grid-row: 4;
  padding-top: 30px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 32px;
`

Password.propTypes = {
  values: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitLogin: PropTypes.func,
}

export default Password
